import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Jednoduchý read-only panel zobrazující kontaktní údaje.
 */
class KontaktniUdajePanel extends Component<WithTranslation> {

    static propTypes = {
        kontaktniUdaje: PropTypes.object.isRequired, // data kontaktních údajů
    };

    render() {
        const {kontaktniUdaje, t} = this.props;
        const kontaktniUdajeRows = [];
        const spolecnostRow = [];
        if (kontaktniUdaje.naSpolecnost) {
            if (kontaktniUdaje.nazevSpolecnost) spolecnostRow.push(kontaktniUdaje.nazevSpolecnost);
            if (kontaktniUdaje.ic) spolecnostRow.push(`${t('cin')}: ${kontaktniUdaje.ic}`);
            if (kontaktniUdaje.dic) spolecnostRow.push(`${t('vatin')}: ${kontaktniUdaje.dic}`);
            if (spolecnostRow.length > 0) kontaktniUdajeRows.push(spolecnostRow.join(", "));
        }
        const uzivatelRow = [];
        if (kontaktniUdaje.jmenoAPrijmeni) uzivatelRow.push(kontaktniUdaje.jmenoAPrijmeni);
        if (kontaktniUdaje.ulice) uzivatelRow.push(kontaktniUdaje.ulice);
        if (kontaktniUdaje.obec) uzivatelRow.push(kontaktniUdaje.obec);
        if (kontaktniUdaje.psc) uzivatelRow.push(kontaktniUdaje.psc);
        if (uzivatelRow.length > 0) kontaktniUdajeRows.push(uzivatelRow.join(", "));
        if (kontaktniUdaje.email) kontaktniUdajeRows.push(`${t('email').toLowerCase()}: ${kontaktniUdaje.email}`);
        if (kontaktniUdaje.telefon) kontaktniUdajeRows.push(`${t('phone').toLowerCase()}: ${kontaktniUdaje.telefon}`);
        return <Card>
            <CardHeader>
                <h2>{t('contact_and_billing_information')}</h2>
            </CardHeader>
            <CardBody>
                {kontaktniUdajeRows.map((row, index) => <div key={index} className="mb-3">{row}</div>)}
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(KontaktniUdajePanel));
